import React from 'react';
import {
  Box,
  Checkbox,
  Text,
  VStack,
  Stack,
} from '@chakra-ui/react';

function GroupCheckbox({ group, selectedIds, onToggleGroup, onToggleItem }) {
  const childIds = group.children.map((c) => c.id);
  const allSelected = childIds.length > 0 && childIds.every((id) => selectedIds.includes(id));
  const someSelected = childIds.some((id) => selectedIds.includes(id));

  return (
    <Box borderWidth="1px" borderRadius="md" p={3}>
      <Checkbox
        isChecked={allSelected}
        isIndeterminate={!allSelected && someSelected}
        onChange={() => onToggleGroup(childIds)}
        fontWeight="600"
        mb={2}
      >
        {group.label}
      </Checkbox>
      <Stack pl={6} spacing={2}>
        {group.children.map((child) => (
          <Checkbox
            key={child.id}
            isChecked={selectedIds.includes(child.id)}
            onChange={() => onToggleItem(child.id)}
          >
            {child.label}
          </Checkbox>
        ))}
      </Stack>
    </Box>
  );
}

function LeafCheckbox({ item, selectedIds, onToggleItem }) {
  return (
    <Box borderWidth="1px" borderRadius="md" p={3}>
      <Checkbox
        isChecked={selectedIds.includes(item.id)}
        onChange={() => onToggleItem(item.id)}
        fontWeight="600"
      >
        {item.label}
      </Checkbox>
    </Box>
  );
}

export default function PermissionTreePicker({
  tree = [],
  selectedIds = [],
  onChange,
}) {
  const toggleItem = (id) => {
    const next = selectedIds.includes(id)
      ? selectedIds.filter((x) => x !== id)
      : [...selectedIds, id];
    onChange(next);
  };

  const toggleGroup = (childIds) => {
    const allSelected = childIds.every((id) => selectedIds.includes(id));
    if (allSelected) {
      onChange(selectedIds.filter((id) => !childIds.includes(id)));
    } else {
      onChange([...new Set([...selectedIds, ...childIds])]);
    }
  };

  if (!tree.length) {
    return <Text color="gray.500" fontSize="sm">No hay permisos configurados</Text>;
  }

  return (
    <VStack align="stretch" spacing={3} maxH="420px" overflowY="auto" pr={1}>
      {tree.map((node) => (
        node.children?.length ? (
          <GroupCheckbox
            key={node.label}
            group={node}
            selectedIds={selectedIds}
            onToggleGroup={toggleGroup}
            onToggleItem={toggleItem}
          />
        ) : (
          <LeafCheckbox
            key={node.id}
            item={node}
            selectedIds={selectedIds}
            onToggleItem={toggleItem}
          />
        )
      ))}
    </VStack>
  );
}
